import { vue } from '@/main';

export default function () {
  return [
    {
      key: 'orgIds',
      type: 'org',
      props: {
        clearable: true,
        multiple: true,
      },
      collapsed: true,
      collapsedMinWidth: '450px',
    },
    {
      key: 'buIds',
      label: 'businessUnit',
      type: 'bu',
      props: {
        clearable: true,
        multiple: true,
      },
      collapsed: true,
      collapsedMinWidth: '450px',
    },
    {
      key: 'userIds',
      label: 'representative',
      type: 'user',
      props: {
        clearable: true,
        multiple: true,
      },
      collapsed: true,
      collapsedMinWidth: '450px',
    },
    // Client-attribute filters (resolved against the Client collection on the backend)
    {
      key: 'countries',
      label: 'country',
      type: 'select',
      props: {
        options: vue.$t('countryList'),
        label: 'name',
        reduce: country => country.code,
        clearable: true,
        multiple: true,
      },
      collapsed: true,
      collapsedMinWidth: '450px',
    },
    {
      key: 'affiliateIds',
      label: 'affiliateId',
      type: 'affiliate',
      props: {
        clearable: true,
        multiple: true,
      },
      collapsed: true,
      collapsedMinWidth: '450px',
    },
    {
      key: 'statusIds',
      label: 'statusIds',
      type: 'status',
      props: {},
      collapsed: true,
      collapsedMinWidth: '450px',
    },
  ];
}
